import { Stack, Typography } from "@mui/material";

export default function InfoRemoverTitulo({
    resposta
}: InfoRemoverTituloProps) {
    return (
        <Stack>
            <Typography variant="caption" component='div' my={0.5}>
                Títulos removidos: <b>{resposta.map(tit => tit.titulo_label).join(', ')}</b>
            </Typography>
        </Stack>
    )
}

interface InfoRemoverTituloProps {
    resposta: {
        titulo: string
        titulo_label: string
    }[]
}


